// El API devuelve errores y avisos como códigos ({ code, params }); acá se traducen.
const CODES_PREFIX = 'bulkAssociation.codes';

const translateIssue = (t, { code, params = {} }) => t(`${CODES_PREFIX}.${code}`, {
  ...params,
  defaultValue: code,
});

// Error de archivo: si no hay código conocido, se usa el mensaje genérico.
const translateFileError = (t, { errorCode, errorParams = {} }, fallbackKey) => {
  const fallback = t(fallbackKey);
  if (!errorCode) return fallback;
  return t(`${CODES_PREFIX}.${errorCode}`, { ...errorParams, defaultValue: fallback });
};

export { translateIssue, translateFileError };
